import React from "react";
import FaviconSVG from "./FaviconSVG";
import { createPortal } from "react-dom";

const Spin = ({
  fullscreen = false,
  full = true,
  expand = false,
  smallModal = false,
  tabWidth = false,
}) => {
  return (
    <>
      {fullscreen ? (
        createPortal(
          <div
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
            onPointerDown={(e) => e.stopPropagation()} // prevent dialog outside detection
            onMouseDown={(e) => e.stopPropagation()}
            style={
              fullscreen
                ? {
                    position: "fixed",
                    inset: 0,
                    width: "100vw",
                    height: "100vh",
                    zIndex: 2147483647,
                    pointerEvents: "auto",
                  }
                : expand
                ? tabWidth
                  ? {
                      position: "absolute",
                      // background: "rgb(255 255 255 / 25%)",
                      width: "calc(100% - 3rem)",
                      height: "calc(100% - 3rem)",
                      zIndex: 30,
                      top: 0,
                      left: 0,
                    }
                  : {
                      position: "absolute",
                      // background: "rgb(255 255 255 / 25%)",
                      width: "100%",
                      height: "100%",
                      zIndex: 30,
                      top: 0,
                      left: 0,
                    }
                : {
                    position: "absolute",
                    // background: "rgb(255 255 255 / 25%)",
                    width: "100%",
                    height: full ? "100vh" : "calc(100vh - 100px)",
                    zIndex: 30,
                  }
            }
            className={fullscreen ? "bg-muted/50" : "bg-muted/50 rounded-lg"}
          >
            <div
              style={
                fullscreen
                  ? {
                      position: "fixed",
                      top: "50%",
                      left: "50%",
                      width: "100%",
                      height: "auto",
                      transform: "translate(-50%, 0%)",
                    }
                  : expand
                  ? smallModal
                    ? {
                        position: "absolute",
                        top: "30%",
                        left: "50%",
                        width: "100%",
                        height: "auto",
                        transform: "translate(-50%, 0%)",
                      }
                    : {
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: "100%",
                        height: "auto",
                        transform: "translate(-50%, 0%)",
                      }
                  : {
                      position: "fixed",
                      top: "50%",
                      left: "50%",
                      width: "100%",
                      height: "auto",
                      transform: "translate(-50%, 0%)",
                    }
              }
            >
              <div className="relative flex justify-center items-center">
                <div className="absolute animate-spin rounded-full h-14 w-14 border-t-2 border-b-1  border-webPrimary"></div>
                <div className="w-11 h-12 overflow-hidden ">
                  <FaviconSVG className="h-full w-full !text-webPrimary !fill-webPrimary" />
                </div>
              </div>
            </div>
          </div>,
          document.body
        )
      ) : (
        <div
          style={
            fullscreen
              ? {
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  zIndex: 9999,
                  pointerEvents: "auto",
                }
              : expand
              ? tabWidth
                ? {
                    position: "absolute",
                    // background: "rgb(255 255 255 / 25%)",
                    width: "calc(100% - 3rem)",
                    height: "calc(100% - 3rem)",
                    zIndex: 30,
                    top: 0,
                    left: 0,
                  }
                : {
                    position: "absolute",
                    // background: "rgb(255 255 255 / 25%)",
                    width: "100%",
                    height: "100%",
                    zIndex: 30,
                    top: 0,
                    left: 0,
                  }
              : {
                  position: "absolute",
                  // background: "rgb(255 255 255 / 25%)",
                  width: "100%",
                  height: full ? "100vh" : "calc(100vh - 100px)",
                  zIndex: 30,
                }
          }
          className="bg-muted/50 rounded-lg"
        >
          <div
            style={
              expand
                ? smallModal
                  ? {
                      position: "absolute",
                      top: "30%",
                      left: "50%",
                      width: "100%",
                      height: "auto",
                      transform: "translate(-50%, 0%)",
                    }
                  : {
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      width: "100%",
                      height: "auto",
                      transform: "translate(-50%, 0%)",
                    }
                : {
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    width: "100%",
                    height: "auto",
                    transform: "translate(-50%, 0%)",
                  }
            }
          >
            <div className="relative flex justify-center items-center">
              <div className="absolute animate-spin rounded-full h-14 w-14 border-t-2 border-b-1  border-webPrimary"></div>
              <div className="w-11 h-12 overflow-hidden ">
                <FaviconSVG className="h-full w-full !text-webPrimary !fill-webPrimary" />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Spin;
